import RequestDetails from "@/components/RequestDetails/RequestDetails.vue";
import AgentData from "@/components/RequestDetails/AgentData.vue";
import EstateData from "@/components/RequestDetails/EstateData.vue";
import FundData from "@/components/RequestDetails/FundData.vue";
import FundCalc from "@/components/RequestDetails/FundCalc.vue";
import RequestAttachments from "@/components/RequestDetails/RequestAttachments.vue";
import PrePayment from "@/components/RequestDetails/PrePayment.vue";
// import RequestLog from "@/components/RequestDetails/RequestLog.vue";
import RequestLog from "@/components/RequestDetails/RequestLogNew.vue";
import RequestTickets from "@/components/RequestDetails/RequestTickets.vue";
import RequestCalls from "@/components/RequestDetails/RequestCalls.vue";

// Customer Service request details (duplicate route + wrapper components)
import CSRequestDetails from "@/components/RequestDetailsCustomerService/RequestDetails.vue";
import CSAgentData from "@/components/RequestDetailsCustomerService/AgentData.vue";
import CSEstateData from "@/components/RequestDetailsCustomerService/EstateData.vue";
import CSFundData from "@/components/RequestDetailsCustomerService/FundData.vue";
import CSFundCalc from "@/components/RequestDetailsCustomerService/FundCalc.vue";
import CSRequestAttachments from "@/components/RequestDetailsCustomerService/RequestAttachments.vue";
import CSPrePayment from "@/components/RequestDetailsCustomerService/PrePayment.vue";
import CSRequestLog from "@/components/RequestDetailsCustomerService/RequestLogNew.vue";
import CSRequestTickets from "@/components/RequestDetailsCustomerService/RequestTickets.vue";
import CSRequestCalls from "@/components/RequestDetailsCustomerService/RequestCalls.vue";
import NotFound from "@/views/agent2/NotFound.vue";
import AlternativeVacation from "@/views/agent2/Vacations/StatusVacation.vue";
import QuestionAndAnswer2 from "@/views/agent2/questionAndAnswer2/PostDataDetails.vue";
import RequestLogNewTap from "@/components/RequestDetails/RequestLogNewTap.vue";


export const commonRouter = [
    {
        path: "/requests/:id",
        name: "request_details",
        component: RequestDetails,
        meta: { icon: "", listed: false, page_name: "تفاصيل الطلب" },
        redirect: { name: "agent_data" },
        children: [
            {
                path: "agent-data",
                name: "agent_data",
                component: AgentData,
                meta: { icon: "", listed: false },
            },
            {
                path: "real-estate-data",
                name: "real_estate_data",
                component: EstateData,
                meta: { icon: "", listed: false },
            },
            {
                path: "fund-data",
                name: "fund_data",
                component: FundData,
                meta: { icon: "", listed: false },
            },
            {
                path: "fund-calculator",
                name: "fund_calc",
                component: FundCalc,
                meta: { icon: "", listed: false },
            },
            {
                path: "attachments",
                name: "attachments",
                component: RequestAttachments,
                meta: { icon: "", listed: false },
            },
            {
                path: "prepayment",
                name: "prepayment",
                component: PrePayment,
                meta: { icon: "", listed: false },
            },
            {
                path: "logs",
                name: "logs",
                component: RequestLog,
                meta: { icon: "", listed: false },
            },
            {
                path: "tickets",
                name: "tickets",
                component: RequestTickets,
                meta: { icon: "", listed: false },
            },
            {
                path: "calls",
                name: "calls",
                component: RequestCalls,
                meta: { icon: "", listed: false },
            },
        ],
    },

    // Customer Service: duplicated request details route (kept separate path, no named children to avoid name collisions)
    {
        path: "/customer-service/requests/:id",
        name: "customer_service_request_details",
        component: CSRequestDetails,
        meta: { icon: "", listed: false, page_name: "تفاصيل الطلب", is_customer_service_details: 1 },
        redirect: (to) => ({ path: `/customer-service/requests/${to.params.id}/agent-data` }),
        children: [
            {
                path: "agent-data",
                component: CSAgentData,
                name: "customer_service_agent_data",
                meta: { icon: "", listed: false },
            },
            {
                path: "real-estate-data",
                component: CSEstateData,
                name: "customer_service_real_estate_data",
                meta: { icon: "", listed: false },
            },
            {
                path: "fund-data",
                component: CSFundData,
                name: "customer_service_fund_data",
                meta: { icon: "", listed: false },
            },
            {
                path: "fund-calculator",
                component: CSFundCalc,
                name: "customer_service_fund_calc",
                meta: { icon: "", listed: false },
            },
            {
                path: "attachments",
                component: CSRequestAttachments,
                name: "customer_service_attachments",
                meta: { icon: "", listed: false },
            },
            {
                path: "prepayment",
                component: CSPrePayment,
                name: "customer_service_prepayment",
                meta: { icon: "", listed: false },
            },
            {
                path: "logs",
                component: CSRequestLog,
                name: "customer_service_logs",
                meta: { icon: "", listed: false },
            },
            {
                path: "tickets",
                component: CSRequestTickets,
                name: "customer_service_tickets",
                meta: { icon: "", listed: false },
            },
            {
                path: "calls",
                component: CSRequestCalls,
                name: "customer_service_calls",
                meta: { icon: "", listed: false },
            },
        ],
    },

    {
        path: "/user/questionnaire-details/data/:id",
        name: 'questionnaire_details',
        component: QuestionAndAnswer2,
        meta: { icon: "", listed: false, page_name: "تفاصيل الاستبيان" },
    },

    {
        path: "/request/request-history/:id",
        name: "request_log_new_tap",
        component: RequestLogNewTap,
        meta: { icon: "", listed: false, page_name: "سجل الطلب" },
    },

    {
        path: "/:pathMatch(.*)*",
        name: "NotFound",
        component: NotFound,
        meta: {
            title: "Page 404 Not Found",
        },
    },
    {
        path: "/vacations/status/:id",
        name: 'alternative_vacation_details',
        component: AlternativeVacation,
        meta: {},
    },
]